// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a79f0839","703":"5301bba2","787":"baeb6a3f"}[chunkId] + ".chunk.js";
};